import React from 'react';
import VoxelText from '../../../components/voxel/Text/VoxelText';
import VoxelTooltipShort from '../../../components/voxel/Tooltip/VoxelTooltipShort';
import InfoIcon from '../../../components/voxel/Icons/InfoIcon';

export interface ProgressDashboardMiniatureTitleProps {
  title: string;
  tooltip?: string;
  loadingPlaceholder: boolean;
}

export const ProgressDashboardMiniatureTitle: React.FC<ProgressDashboardMiniatureTitleProps> = ({
  title,
  tooltip,
  loadingPlaceholder,
}) => {
  if (loadingPlaceholder) {
    return <div className="w-16 h-6 bg-gray-200/50 animate-pulse rounded" />;
  }
  return (
    <div className="flex flex-row items-center gap-2">
      <VoxelText
        variant="title3"
        userSelectClass="select-none"
        color="light"
        paddingBot={false}
        paddingTop={false}
      >
        {title}
      </VoxelText>
      {!!tooltip && (
        <VoxelTooltipShort message={tooltip}>
          <span>
            <InfoIcon size="sm" />
          </span>
        </VoxelTooltipShort>
      )}
    </div>
  );
};

export default ProgressDashboardMiniatureTitle;
